//import {axiosClient} from '../../main'
import Vue from 'vue'
//import axios from '../../http/axios/index.js'

export default {
  
  fetchSubscribers_gained ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/admin/dashboard/getAllSubscribers')
        .then((response) => {
          // console.log('sub data', response.data.data)
          const subscribers_gained = {
            series: [
              {
                name: 'Subscribers',
                data: response.data.data.series
              }
            ],
            analyticsData: {
              subscribers: response.data.data.subscribers
            }
          }
          commit('SET_SUBSCRIBERS_GAINED', subscribers_gained)
          resolve(response)
        })
        .catch((error) => { reject(error) }) 
    })
  },

  fetchRevenueGenerated ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/admin/dashboard/fetchRevenueGenerated')
        .then((response) => {
          // console.log('sub data', response.data.data)
          const revenueGenerated = {
            series: [
              {
                name: 'Revenue',
                data: response.data.data.series
              }
            ],
            analyticsData: {
              revenue: response.data.data.revenue
            }
          }
          commit('SET_REVENUE_GENERATED', revenueGenerated)
          resolve(response)
        })
        .catch((error) => { reject(error) }) 
    })
  },

  fetchQuarterlySales ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/admin/dashboard/fetchQuarterlySales')
        .then((response) => {
          // console.log('sub data', response.data.data)
          const quarterlySales = {
            series: [
              {
                name: 'Sales',
                data: response.data.data.series
              }
            ],
            analyticsData: {
              sales: response.data.data.sales //should be in percentage
            }
          }
          commit('SET_QUARTERLY_SALES', quarterlySales)
          resolve(response)
        })
        .catch((error) => { reject(error) }) 
    })
  },

  fetchOrdersRecevied ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/admin/dashboard/fetchOrdersRecevied')
        .then((response) => {
          // console.log('sub data', response.data.data)
          const ordersRecevied = {
            series: [
              {
                name: 'Orders',
                data: response.data.data.series
              }
            ],
            analyticsData: {
              orders: response.data.data.orders 
            }
          }
          commit('SET_ORDER_RECIEVED', ordersRecevied)
          resolve(response)
        })
        .catch((error) => { reject(error) }) 
    })
  },

  fetchRevenueComparisionLine ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/admin/dashboard/fetchRevenueComparisionLine')
        .then((response) => {
          // console.log('sub data', response.data.data)
          const revenueComparisonLine = {
            analyticsData: {
              thisMonth: response.data.data.thisMonthRevenue,
              lastMonth: response.data.data.lastMonthRevenue,
              chartOptions: {
                chart: {
                  toolbar: { show: false },
                  dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10
                  }
                },
                stroke: {
                  curve: 'smooth',
                  dashArray: [0, 8],
                  width: [4, 2]
                },
                grid: {
                  borderColor: '#e7e7e7'
                },
                legend: {
                  show: false
                },
                colors: ['#F97794', '#b8c2cc'],
                fill: {
                  type: 'gradient',
                  gradient: {
                    shade: 'dark',
                    inverseColors: false,
                    gradientToColors: ['#7367F0', '#b8c2cc'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                  }
                },
                markers: {
                  size: 0,
                  hover: {
                    size: 5
                  }
                },
                xaxis: {
                  labels: {
                    style: {
                      cssClass: 'text-grey fill-current'
                    }
                  },
                  axisTicks: {
                    show: false
                  },
                  categories: ['01', '05', '09', '13', '17', '21', '26', '31'],
                  axisBorder: {
                    show: false
                  }
                },
                yaxis: {
                  tickAmount: 5,
                  labels: {
                    style: {
                      cssClass: 'text-grey fill-current'
                    },
                    formatter (val) {
                      return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
                    }
                  }
                },
                tooltip: {
                  x: { show: false }
                }
              }
            },
            series: [
              {
                name: 'This Month',
                data: response.data.data.thisMonthSeries
              },
              {
                name: 'Last Month',
                data: response.data.data.lastMonthSeries
              }
            ]
          }
          commit('SET_REVENUE_COMPARISION', revenueComparisonLine)
          resolve(response)
        })
        .catch((error) => { reject(error) }) 
    })
  }
}

